// extracted by mini-css-extract-plugin
export default {"inicioContainer":"Inicio_inicioContainer__hQBp+"};